import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Button, FormGroup, Label, Row, Col, Input, CardBody, Container, Card, FormText, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Breadcrumbs from "components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { absentLeaveUpdate, absentLopUpdate, absentOdUpdate, absentWeekOffUpdate, clearAbsentError, fetchAbsentList, fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchShifts, resetAll } from "store/actions";
import TableContainer from "components/Common/TableContainer";
import CustomSelect from "components/Common/custom-select";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomDatePicker from "common/CustomDatePicker";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const AbsentList = () => {
    const [accessRight, setAccessRight] = useState(null);
    const location = useLocation();
    const history = useHistory();
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
    const [authDetails, setAuthDetails] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prev) => !prev);

    const dispatch = useDispatch()

    const {
        absentList,
        dropdownAutoList,
        categories,
        departments,
        designations,
        loading,
        success,
        error,
        } = useSelector((state) => ({
        categories: state.CategoryMaster?.categories ?? [],
        departments: state.DepartmentMaster?.departments ?? [],
        designations: state.DesignationMaster?.designations ?? [],
        dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
        absentList: state.AttendanceLeaveManagReducer?.absentList ?? [],

        loading: state.AttendanceLeaveManagReducer?.loading,
        error: state.AttendanceLeaveManagReducer?.error,
        success: state.AttendanceLeaveManagReducer?.success,
    }));
    const [timesheetApprovalData, setTimesheetApprovalData] = useState();
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchDepartments(unitId));
        dispatch(fetchCategories(unitId));
        dispatch(fetchDesignations(unitId));
        dispatch(fetchShifts(unitId));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            handleCancel()
        }
    }, [authDetails,success,dispatch]);  

    useEffect(() => {
        if (absentList && absentList.length > 0) {          
            const initializedData = (absentList || []).map(row => ({
            ...row,
                selectedOption: "Discussion",
            }));
            setTimesheetApprovalData(initializedData)
        }else{
            setTimesheetApprovalData([])
        }
    }, [absentList])


    const handleBulkActionChange = (action, checked) => {
        const updatedData = (timesheetApprovalData || []).map((row) => ({
            ...row,
            selectedOption: checked ? action : "", // clear if unchecked
        }));
        setTimesheetApprovalData(updatedData);
    };

    const handleOptionChange = (punchDate, action, checked) => {
        const updatedData = timesheetApprovalData.map((row) => {
            if (row.punch_date === punchDate) {
            return { ...row, selectedOption: checked ? action : "" }; // toggle by punch_date
            }
            return row;
        });
        setTimesheetApprovalData(updatedData);
    };

    const columns = [
            { Header: "S.No", Cell: ({ row }) => timesheetApprovalData.length - row.index, className: "serial-no", applyHeaderClass: true, },
            { Header: "Code", accessor: "emp_no" },
            { Header: "Employee Name", accessor: "emp_name" },
            { Header: "Department", accessor: "department" },
            { Header: "Shift Code", accessor: "shift_code" },
            { Header: "Shift Timings", accessor: "shift_time" },
            { Header: "Date", accessor: "punch_date" },
            { Header: "Session", accessor: "session" },
            // { Header: "WO Bal", accessor: "" },
            { Header: "CL Bal", accessor: "cl_lvebalance" },
            // {
            //     id: "approve",
            //     Header: () => {
            //         const allSelected = (timesheetApprovalData || []).every(
            //         (row) => row.selectedOption === "Approve"
            //         );

            //         return (
            //         <div className="text-center">
            //             <Input
            //             type="checkbox"
            //             checked={allSelected}
            //             onChange={(e) => handleBulkActionChange("Approve", e.target.checked)}
            //             />
            //         </div>
            //         );
            //     },
            //     Cell: ({ row }) => (
            //         <div className="d-flex justify-content-center align-items-center">
            //         <Input
            //             type="checkbox"
            //             checked={row.original.selectedOption === "Approve"}
            //             onChange={(e) =>
            //             handleOptionChange(row.original.punch_date, "Approve", e.target.checked)
            //             }
            //         />
            //         </div>
            //     ),
            // }
            {
                id: "selection",
                className: "serial-no",
                applyHeaderClass: true,
                Header: ({ getToggleAllRowsSelectedProps }) => (
                <div className="text-center">
                    <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
                </div>
                ),
                Cell: ({ row }) => (
                <div className="text-center">
                    <input type="checkbox" {...row.getToggleRowSelectedProps()} />
                </div>
                ),
            },
    ];

    const handleSelectedRowsChange = React.useCallback((rows) => {
    setSelectedRows(rows);
    }, []);

     useEffect(() => {
        dispatch(resetAll());
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchDepartments(unitId));
        dispatch(fetchCategories(unitId));
        dispatch(fetchDesignations(unitId));
        dispatch(fetchEmployeeDropdownAutoList(unitId));
    }, [dispatch]);

    const formik = useFormik({
        initialValues: {
            category: [],        
            department: [],      
            designation: [],     
            employee: null,      
            fromDate: "", 
            toDate:"",       
        },
        validationSchema: Yup.object({                
            fromDate: Yup.string().nullable()
                .required("From Date is required"),
            toDate: Yup.string().nullable()
                .required("To Date is required")
                .test("is-greater", "To Date must be greater than From Date", function (value) {
                const { fromDate } = this.parent;
                if (!fromDate || !value) return true; // skip if one is missing (required already handles)
                return new Date(value) >= new Date(fromDate);
            }),
        }),
        onSubmit: (values) => {
            const formData = new FormData();
            formData.append("emp_id", values.employee?.value || 0);         
            formData.append("from_date", values.fromDate || "");                 
            formData.append("to_date", values.toDate || ""); 
            formData.append("dept_id", values.department?.join(",") || 0);  
            formData.append("cat_id", values.category?.join(",") || 0);     
            formData.append("design_id", values.designation?.join(",") || 0);     
            formData.append("unit_id", authDetails?.unit_id || 0);
            formData.append("create_by", authDetails?.user_id || 0);
            dispatch(fetchAbsentList(formData))
        },
    });

    // 🔹 Common Submit Handler
    // const handleAbsentUpdate = (type) => {
    //     // ✅ Filter only selected absent rows
    //     const updatedAbsent = (timesheetApprovalData || [])
    //     .filter(item => item.selectedOption === "Approve") // ✅ Only Approve
    //     .map(item => ({
    //         emp_id: item.emp_id?.toString() || "",
    //         punch_date: item.api_punch_date,
    //         session: item.session || "",
    //     }));

    //     if (updatedAbsent.length === 0) {
    //         Swal.fire({
    //         icon: "warning",
    //         title: "No Selection",
    //         text: "Please select at least one before proceeding.",
    //         });
    //         return;
    //     }

    //     // ✅ Final payload structure
    //     const payload = { listabsentdata: updatedAbsent };
    //     const convertObject = JSON.stringify(payload);

    //     console.log('type > ',type)
    //     console.log('convertObject > ',convertObject)

    //     // ✅ FormData build
    //     const formData = new FormData();
    //     formData.append("items", convertObject);
    //     formData.append("unit_id", authDetails?.unit_id);
    //     formData.append("create_by", authDetails?.user_id);

    //     switch (type) {
    //         case "LOP":
    //             dispatch(absentLopUpdate(formData));
    //         break;
    //         case "LEAVE":
    //             dispatch(absentLeaveUpdate(formData));
    //         break;
    //         case "OD":
    //             dispatch(absentOdUpdate(formData));
    //         break;
    //         case "WEEKOFF":
    //             dispatch(absentWeekOffUpdate(formData));
    //         break;
    //         default:
    //             Swal.fire("Error", "Invalid action type", "error");
    //     }
    // };

    const handleAbsentUpdate = async (type) => {

    // ✅ No selection check
    if (selectedRows.length === 0) {
        Swal.fire({
        icon: "warning",
        title: "No Selection",
        text: "Please select at least one before proceeding.",
        });
        return;
    }

    // 🔥 Confirmation popup
    const resultConfirm = await Swal.fire({
        title: "Are you sure?",
        text: `Do you want to update selected absent record(s) as ${type}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Update",
        cancelButtonText: "Cancel",
    });

    // ❌ Cancel clicked
    if (!resultConfirm.isConfirmed) return;

    // ✅ Build payload from selected rows
    const updatedAbsent = selectedRows.map(item => ({
        emp_id: item.emp_id?.toString() || "",
        punch_date: item.api_punch_date,
        session: item.session || "",
    }));

    const payload = { listabsentdata: updatedAbsent };
    const convertObject = JSON.stringify(payload);

    // ✅ FormData
    const formData = new FormData();
    formData.append("items", convertObject);
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);

    // ✅ Dispatch based on type
    switch (type) {
        case "LOP":
        dispatch(absentLopUpdate(formData));
        break;

        case "LEAVE":
        dispatch(absentLeaveUpdate(formData));
        break;

        case "OD":
        dispatch(absentOdUpdate(formData));
        break;

        case "WEEKOFF":
        dispatch(absentWeekOffUpdate(formData));
        break;

        default:
        Swal.fire("Error", "Invalid action type", "error");
    }
    };


    const handleCancel = () => {
        setTimesheetApprovalData([])
        formik.resetForm()
    }

    const leaveErrorColumns = [
        {
            Header: "Code",
            accessor: "emp_no",
        },
        {
            Header: "Name",
            accessor: "emp_name",
        },
        {
            Header: "Leave Date",
            accessor: "leave_date",
        },
        {
            Header: "Remarks",
            accessor: "Remarks",
        },
    ];

    const weekOffErrorColumns = [
        {
            Header: "Code",
            accessor: "emp_no",
        },
        {
            Header: "Name",
            accessor: "emp_name",
        },
        {
            Header: "Week-Off Date",
            accessor: "week_off_date",
        },
        {
            Header: "Eligible Week-Off",
            accessor: "eligible_weekoff",
        },
        {
            Header: "Availed Week-Off",
            accessor: "availed_weekoff",
        },
        {
            Header: "Remarks",
            accessor: "Remarks",
        },
    ];

    const hasErrorData = Array.isArray(error?.data) && error.data.length > 0;

    const isWeekOff = Array.isArray(error?.data) && error.data.length > 0 && "week_off_date" in error.data[0];

    const res_columns = isWeekOff ? weekOffErrorColumns : leaveErrorColumns;

    return (
        <React.Fragment>
            <Loader loading={loading}/>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Leave Management" breadcrumbItem="AbsentList" />

                    <Col lg="12">
                        <Card>
                            <CardBody>
                                <form onSubmit={formik.handleSubmit}>
                                    <Row >
                                        {/* Category */}
                                        <Col md={3}>
                                            <FormGroup>
                                                <Label>Category</Label>
                                                <CustomSelect
                                                    id="category"
                                                    name="category"
                                                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                                                    value={
                                                        categories
                                                            .filter(cat => formik.values.category?.includes(cat.empCatgryid))
                                                            .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                                                    }
                                                    onChange={val => formik.setFieldValue('category', val ? val.map(v => v.value) : [])}
                                                    isMulti
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                                                />
                                                {formik.errors.category && formik.touched.category && (
                                                    <div className="text-danger">{formik.errors.category}</div>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        {/* Department */}
                                        <Col md={3}>
                                            <FormGroup>
                                                <Label>Department</Label>
                                                <CustomSelect
                                                    id="department"
                                                    name="department"
                                                    options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                                                    value={
                                                        departments
                                                            .filter(dept => formik.values.department?.includes(dept.departmentId))
                                                            .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                                                    }
                                                    onChange={val => formik.setFieldValue('department', val ? val.map(v => v.value) : [])}
                                                    isMulti
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}

                                                />
                                                {formik.errors.department && formik.touched.department && (
                                                    <div className="text-danger">{formik.errors.department}</div>
                                                )}
                                            </FormGroup>
                                        </Col>


                                        {/* Designation */}
                                        <Col md={3}>
                                            <FormGroup>
                                                <Label>Designation</Label>
                                                <CustomSelect
                                                    id="designation"
                                                    name="designation"
                                                    options={designations.map(desig => ({ value: desig.desig_id, label: desig.designation }))}
                                                    value={
                                                        designations
                                                            .filter(desig => formik.values.designation?.includes(desig.desig_id))
                                                            .map(desig => ({ value: desig.desig_id, label: desig.designation }))
                                                    }
                                                    onChange={val => formik.setFieldValue('designation', val ? val.map(v => v.value) : [])}
                                                    isMulti
                                                    onBlur={formik.handleBlur}
                                                    className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}

                                                />
                                                {formik.errors.designation && formik.touched.designation && (
                                                    <div className="text-danger">{formik.errors.designation}</div>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={3}>
                                            <FormGroup>
                                            <Label for="employee">Employee</Label>
                                            <CustomSelect
                                                id="employee"
                                                name="employee"
                                                options={(dropdownAutoList || []).map(emp => ({ value: emp.emp_id.toString(), label: emp.emp_no }))}
                                                value={formik.values.employee || null}
                                                onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                                                onBlur={formik.handleBlur}
                                                className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                                            />
                                            {formik.touched.employee && formik.errors.employee && (
                                                <div className="text-danger">{formik.errors.employee}</div>
                                            )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup>
                                            <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                                            <CustomDatePicker
                                                name="fromDate"
                                                value={formik.values.fromDate || ""}
                                                onChange={(date) => formik.setFieldValue("fromDate", date)}
                                                onBlur={formik.handleBlur}
                                                disableFuture={true}
                                                className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                            />
                                            {formik.touched.fromDate && formik.errors.fromDate && (
                                                <div className="text-danger">{formik.errors.fromDate}</div>
                                            )}
                                            </FormGroup>
                                        </Col>

                                        <Col md={3} className="mb-3">
                                            <FormGroup>
                                            <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                                            <CustomDatePicker
                                                name="toDate"
                                                value={formik.values.toDate || ""}
                                                onChange={(date) => formik.setFieldValue("toDate", date)}
                                                onBlur={formik.handleBlur}
                                                disableFuture={true}
                                                className={`form-control ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                                            />
                                            {formik.touched.toDate && formik.errors.toDate && (
                                                <div className="text-danger">{formik.errors.toDate}</div>
                                            )}
                                            </FormGroup>
                                        </Col>

                                        {/* Buttons */}
                                        <Col className="d-flex align-items-center justify-content-end mob-center">
                                            <Button type="submit" className="btn button-search me-2">
                                                <i className="fas fa-search me-1" /> Search
                                            </Button>
                                            <Button type="reset" color="secondary" onClick={handleCancel} className="btn button-cancel me-2"> <i className="fas fa-sync me-1" /> Cancel
                                            </Button>
                                            {/* <Button type="button" className="btn button-export me-2">
                                                <i className="fas fa-file-export me-1" /> Export
                                            </Button> */}
                                            {timesheetApprovalData && timesheetApprovalData.length > 0 && (
                                                <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" className="me-2">
                                                    <DropdownToggle color="primary" className="btn button-export mt-0">
                                                        <i className="fas fa-file-export me-1" /> Export
                                                    </DropdownToggle>
                                                    <DropdownMenu>
                                                        <DropdownItem onClick={() => exportEmployeeToExcel(timesheetApprovalData, authDetails?.unit_fullname, authDetails?.unit_address, "Absent List Details")} >
                                                        <i className="fas fa-file-excel me-2 text-success" />
                                                        Export to Excel
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => exportEmployeeToPDF(timesheetApprovalData, authDetails?.unit_fullname, authDetails?.unit_address, "Absent List Details", columns)}>
                                                        <i className="fas fa-file-pdf me-2 text-danger" />
                                                        Export to PDF
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </Dropdown> 
                                            )}
                                           {(canEdit || canCreate) && (
                                                <>
                                                    <Button color="success" type="button" onClick={() => handleAbsentUpdate("LEAVE")} className="me-2">Leave</Button>
                                                    <Button color="primary" type="button" onClick={() => handleAbsentUpdate("LOP")} className="me-2">LOP</Button>
                                                    <Button color="danger" type="button" onClick={() => handleAbsentUpdate("OD")} className="me-2">Onduty</Button>
                                                    <Button color="warning" type="button" onClick={() => handleAbsentUpdate("WEEKOFF")}>Weekoff</Button>
                                                </>
                                            )}                                         
                                            
                                        </Col>
                                    </Row>
                                </form>
                            </CardBody>
                        </Card>

                        <Card>
                            <CardBody>
                                <TableContainer columns={columns} data={timesheetApprovalData && timesheetApprovalData.length > 0 ? timesheetApprovalData : []} onSelectedRowsChange={handleSelectedRowsChange} isGlobalFilter={true} customPageSize={10} className="custom-header-css" />
                            </CardBody>
                        </Card>
                    </Col>
                    {hasErrorData && (
                         <Modal
                            isOpen={hasErrorData}
                            size="lg"
                            toggle={() => dispatch(clearAbsentError())}
                         >
                            <ModalHeader toggle={() => dispatch(clearAbsentError())} className="bg-danger text-white absent-modal-header">
                                {error?.message}
                            </ModalHeader>

                            <ModalBody>
                                <TableContainer
                                    columns={res_columns}
                                    data={error?.data || []}
                                    isGlobalFilter={true}
                                    customPageSize={10}
                                    tableSorter={true}
                                />
                            </ModalBody>
                        </Modal>
                    )}                     
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AbsentList;

